(function() {
    'use strict';

    angular
        .module('wamasysApp')
        .controller('ExpenseTypeDeleteController',ExpenseTypeDeleteController);

    ExpenseTypeDeleteController.$inject = ['$uibModalInstance', 'entity', 'ExpenseType'];

    function ExpenseTypeDeleteController($uibModalInstance, entity, ExpenseType) {
        var vm = this;
        vm.expenseType = entity;
        vm.clear = function() {
            $uibModalInstance.dismiss('cancel');
        };
        vm.confirmDelete = function (id) {
            ExpenseType.delete({id: id},
                function () {
                    $uibModalInstance.close(true);
                });
        };
    }
})();
